// consts.js

export const routes = {
  investments: '/investments',
  AddInvestment: '/investments/add-investment',
  editInvestment: '/investments/edit-investment/:id',
  inquiryRequests: '/inquiry-requests',
  profile: '/profile',
  login: '/login',
  register: '/register',
  notFound: '/404',
  serviceTable: '/services',
  addService: '/services/add-service',
  editService: '/services/edit-service/:id',
  projectTable: '/projects',
  addProject: '/projects/add-project',
  editProject: '/projects/edit-project/:id',
  documents : '/documents'
};
export const EditServiceRoute = (id: number) => `/services/edit-service/${id}`;
export const EditProjectRoute = (id: number) => `/projects/edit-project/${id}`;
export const EditInvestmentRoute = (id: number) =>
  `/investments/edit-investment/${id}`;

export const protectedRoutesArray = [
  routes.investments,
  // routes.AddInvestment,
  // routes.editInvestment,
  routes.inquiryRequests,
  routes.profile,
  routes.serviceTable,
  routes.addService,
  routes.editService,
  routes.projectTable,
  routes.addProject,
  routes.editProject,
  routes.documents,
];

export const unprotectedRoutes = [routes.login, routes.register];

export const sidebarLinks = [
  { title: 'Investments', link: routes.investments },
  // { title: 'Add Investment', link: routes.AddInvestment },
  // { title: 'Edit Investment', link: routes.editInvestment },
  { title: 'Contact Requests', link: routes.inquiryRequests },
  { title: 'Services', link: routes.serviceTable },
  // { title: 'Add Service', link: routes.addService },
  { title: 'Projects', link: routes.projectTable },
  { title: 'Documents', link: routes.documents },

  // { title: 'Edit Service', link: routes.editService },
  // { title: 'Profile', link: routes.profile },
];
